import classNames from "classnames";
import { Component } from "react";
import { EntityTypeFilter } from "@app/exports/exportModels";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";

type AccuracySelectEntityTypeFilterProps = {
  disabled: boolean;
  onEntityTypeIncludeChange: (selected: boolean, isPractitioner: boolean) => void;
  onEntityTypeIncludeChangeDropdown: (selectedItems: DropdownItem<string>[]) => void;
  entityTypeFilter: EntityTypeFilter;
}

class WrappedAccuracySelectEntityTypeFilter extends Component<AccuracySelectEntityTypeFilterProps> {
  private readonly practitionerDropdownItem: DropdownItem<string> = { key: "practitioner", name: "1 - Practitioner", };
  private readonly serviceLocationDropdownItem: DropdownItem<string> = { key: "servicelocation", name: "2 - Service Location", }

  public render() {
    const hasIncludes = this.props.entityTypeFilter.includePractitionerEntityType || this.props.entityTypeFilter.includeServiceLocationEntityType;

    return (
      <>
        <p className="lead mb0 demibold">Entity Type Filter{this.props.disabled && <span>: Selected</span>}</p>
        <p className="mb-1">Please select the entity types to include:</p>

        <div className={classNames("form-group row", { "text-danger": !hasIncludes })}>
          <label className="col-12 col-form-label ptb0 text-start">
            {!hasIncludes && <i className="fa fa-exclamation-triangle mt5" style={{ position: "absolute" }} />}
          </label>

          <div className="col-12 mt0">
            <MultiselectDropdown
              containerClassName="w-100"
              label="Entity Type Filter"
              customSelectInputText={this.getDropdownText()}
              hideLabel={true}
              items={[this.practitionerDropdownItem, this.serviceLocationDropdownItem]}
              testId="accuracy-select-entity-type-filter__dropdown"
              onSelectionChanged={(selectedItems) => { this.props.onEntityTypeIncludeChangeDropdown(selectedItems) }}
              disabled={this.props.disabled}
              selectedItems={this.getSelectedItems()}
            />
          </div>
        </div>
      </>
    );
  }

  private getDropdownText = () => {
    if (this.props.entityTypeFilter.includePractitionerEntityType
      && this.props.entityTypeFilter.includeServiceLocationEntityType) {
      return "Practitioner and Service Location";
    } else if (this.props.entityTypeFilter.includePractitionerEntityType) {
      return "Practitioner";
    } else if (this.props.entityTypeFilter.includeServiceLocationEntityType) {
      return "Service Location";
    }
    return "";
  }

  private getSelectedItems = () => {
    const items = [];
    if (this.props.entityTypeFilter.includePractitionerEntityType) {
      items.push(this.practitionerDropdownItem);
    }
    if (this.props.entityTypeFilter.includeServiceLocationEntityType) {
      items.push(this.serviceLocationDropdownItem);
    }
    return items;
  }
}

export default WrappedAccuracySelectEntityTypeFilter;
